import { render, staticRenderFns } from "./TotalPoints.vue?vue&type=template&id=2a0effad&scoped=true"
import script from "./TotalPoints.vue?vue&type=script&lang=js"
export * from "./TotalPoints.vue?vue&type=script&lang=js"
import style0 from "./TotalPoints.vue?vue&type=style&index=0&id=2a0effad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0effad",
  null
  
)

export default component.exports